var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showHeader)?_c('v-header',{staticClass:"header"}):_vm._e(),(_vm.showHeader)?_c('v-headers',{staticClass:"headers"}):_vm._e(),_c('router-view'),_c('v-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }